(function () {

  // ==========================================
  // ACCORDION
  // ==========================================

  function toggleAccordion(trigger) {

    var panel = trigger.nextElementSibling;

    if (!panel || !panel.hasAttribute('data-sr-brand-accordion-panel')) {
      return;
    }

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {

      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', 'hidden');

      return;
    }

    var root = trigger.closest('.sr-brand-mega--mobile');

    if (root) {

      root.querySelectorAll('[data-sr-brand-accordion-trigger]').forEach(function (btn) {

        if (btn === trigger) {
          return;
        }

        btn.setAttribute('aria-expanded', 'false');

        var otherPanel = btn.nextElementSibling;

        if (
          otherPanel &&
          otherPanel.hasAttribute('data-sr-brand-accordion-panel')
        ) {
          otherPanel.setAttribute('hidden', 'hidden');
        }

      });

    }

    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
  }


  // ==========================================
  // CARRUSEL DE MARCAS DESTACADAS
  // ==========================================

  function initFeaturedBrandsCarousel() {

    var tracks = document.querySelectorAll(
      '.sr-brand-mega__featured-track'
    );
  
    tracks.forEach(function (track) {
  
      if (track.dataset.carouselInitialized === 'true') {
        return;
      }
  
      track.dataset.carouselInitialized = 'true';

      var carouselEnabled =
      track.dataset.carouselEnabled === 'true';
  
      var speed =
        parseFloat(track.dataset.carouselSpeed) || 30;
    
      if (!carouselEnabled) {
        return;
      }

      var lastTime = null;
      var animationId = null;
      var isPaused = false;
  
  
      // ------------------------------------------
      // MOVIMIENTO CONTINUO
      // ------------------------------------------
  
      function animate(timestamp) {
  
        if (lastTime === null) {
          lastTime = timestamp;
        }
  
        var delta = timestamp - lastTime;
  
        lastTime = timestamp;
  
  
        if (!isPaused) {
  
          var movement = (speed * delta) / 1000;
  
          track.scrollLeft += movement;
  
  
          // --------------------------------------
          // RECICLAR EL PRIMER ELEMENTO
          // --------------------------------------
  
          var firstItem = track.firstElementChild;
  
          if (firstItem) {
  
            var itemWidth = firstItem.offsetWidth;
            var gap = 10;
  
            if (track.scrollLeft >= itemWidth + gap) {
  
              track.scrollLeft -= itemWidth + gap;
  
              track.appendChild(firstItem);
  
            }
  
          }
  
        }
  
  
        animationId = requestAnimationFrame(animate);
      }
  
  
      // ------------------------------------------
      // INICIAR CARRUSEL
      // ------------------------------------------
  
      animationId = requestAnimationFrame(animate);
  
  
      // ------------------------------------------
      // EL USUARIO TOMA EL CONTROL
      // ------------------------------------------
  
      track.addEventListener('pointerdown', function () {
  
        isPaused = true;
  
      });
  
  
      track.addEventListener('click', function () {
  
        isPaused = true;
  
      });
  
    });
  
  }


  // ==========================================
  // INICIALIZAR CARRUSEL
  // ==========================================

  function init() {

    initFeaturedBrandsCarousel();

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }


  // ==========================================
  // CLICK DEL ACCORDION
  // ==========================================

  document.addEventListener('click', function (event) {

    var trigger = event.target && event.target.closest
      ? event.target.closest('[data-sr-brand-accordion-trigger]')
      : null;

    if (!trigger) {
      return;
    }

    event.preventDefault();

    toggleAccordion(trigger);

  });

})();